import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EquipmentFailureMode } from 'app/viewmodels/equipment/equipment-failure-mode';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TableConfig } from '../../../../component-library/table/table-config';
import { EquipmentFunctionalFailure } from '../../../../viewmodels/equipment/equipment-functional-failure';
import { ModelFunctionsService } from '../../model-functions.service';
import { PlannedMaintenanceFailureTableConfigService } from './planned-maintenance-failure-table-config-service';

@Component({
  selector: 'hb-planned-maintenance-failure-mode-selection-dialog',
  templateUrl: './planned-maintenance-failure-mode-selection-dialog.component.html',
  styleUrls: ['./planned-maintenance-failure-mode-selection-dialog.component.scss'],
})
export class PlannedMaintenanceFailureModeSelectionDialogComponent implements OnInit, OnDestroy {
  @Input() selectedFailureModes: EquipmentFailureMode[] = [];
  failureModes: EquipmentFailureMode[] = [];

  public onClose: Subject<EquipmentFailureMode[]> = new Subject<EquipmentFailureMode[]>();
  private unsubscribe: Subject<boolean> = new Subject();

  public get config(): TableConfig {
    return this.tableConfigService.attributesConfig;
  }

  constructor(private modelFunctionsService: ModelFunctionsService,
              private tableConfigService: PlannedMaintenanceFailureTableConfigService,
              public bsModalRef: BsModalRef) {
  }

  public ngOnInit(): void {
    this.modelFunctionsService.selectedFunctionalFailure.pipe(takeUntil(this.unsubscribe))
      .subscribe((funcFail: EquipmentFunctionalFailure)  => {
        if (funcFail) {
          this.failureModes = funcFail.failureModes;
        }
      });

    this.tableConfigService.initAttributesTableConfig();
  }

  public onSelectionChange(items: EquipmentFailureMode[]) {
    this.selectedFailureModes = items;
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  okClick() {
    this.onClose.next(this.selectedFailureModes);
    this.bsModalRef.hide();
  }
}
